export default "__VITE_ASSET__D7m1NC1s__"